// Landing "Not Old, Just Barrel Aged" (sections/lp-ba.liquid): its own animation and blocks.
// Loaded before the core script (assets/lp1.js), which adds these methods to the page element;
// setUpLook() runs once on load, updateLook(ticked) whenever the after-add popup changes.
window.omLandingParts = window.omLandingParts || [];
window.omLandingParts.push({
    setUpLook() {
      this.setUpPour();
      this.setUpGroove();
    },

    updateLook(ticked) {
      this.updatePour(ticked.length + 1);
    },

    // Look P: fill an Old Fashioned glass to a level (0-1) and show or hide its parts.
    setGlass(box, level, parts) {
      box.querySelector('[data-glass-liquid]').style.transform = 'scaleY(' + level.toFixed(3) + ')';
      Object.entries(parts).forEach(([name, on]) => box.querySelector('[data-glass-' + name + ']')?.classList.toggle('is-in', on));
    },

    // Look P: "Pour another" pours the header glass again.
    setUpPour() {
      const button = this.querySelector('[data-pour-again]');
      if (!button) return;
      const glass = this.querySelector('[data-pour-glass]');
      button.addEventListener('click', () => this.replay(glass, 'is-pouring'));
    },

    // Look N, "How deep in the groove?": each tapped memory moves the tonearm one groove in; the
    // score line follows the count and the first suggested piece that covers the count shows.
    // Look D, "Pour him a glass": the same block with a glass, a finger poured per memory.
    setUpGroove() {
      const block = this.querySelector('[data-groove]');
      if (!block) return;
      const picks = [...block.querySelectorAll('[data-groove-pick]')];
      const arm = block.querySelector('[data-groove-arm]');
      const glass = block.querySelector('[data-groove-glass]');
      const show = () => {
        const count = picks.filter((pick) => pick.getAttribute('aria-pressed') === 'true').length;
        block.querySelector('[data-groove-count]').textContent = String(count);
        if (arm) {
          arm.style.setProperty('--turn', 12 - count * 6 + 'deg');
          block.querySelector('[data-groove-label]').setAttribute('aria-label', 'The needle is ' + count + ' grooves in');
        }
        if (glass) {
          this.setGlass(glass, (0.8 * count) / Math.max(picks.length, 1), {});
          glass.querySelector('svg').setAttribute('aria-label', count ? count + (count === 1 ? ' finger' : ' fingers') + ' poured' : 'An empty glass');
        }
        const score = this.scoreFor(block, count);
        if (score) {
          block.querySelector('[data-groove-title]').textContent = score.title;
          block.querySelector('[data-groove-line]').textContent = score.line;
        }
        this.showPicks(block, count);
      };
      block.addEventListener('click', (event) => {
        const pick = event.target.closest('[data-groove-pick]');
        if (!pick) return;
        pick.setAttribute('aria-pressed', String(pick.getAttribute('aria-pressed') !== 'true'));
        show();
      });
      show();
    },

    // Look P: the popup's glass is a third, two thirds or full for 1, 2 or 3+ pieces.
    // Look D names its steps and levels on the strip (one, two, three fingers).
    updatePour(count) {
      const box = this.upsell.querySelector('[data-sheet-pour]');
      if (!box) return;
      const step = Math.min(count, 3);
      const names = box.dataset.pourNames ? box.dataset.pourNames.split('|') : ['A single', 'A double', 'Top shelf'];
      const levels = box.dataset.pourLevels ? box.dataset.pourLevels.split('|').map(Number) : [0.3, 0.55, 0.8];
      this.setGlass(box, levels[step - 1], { ice: step >= 2, peel: step >= 3 });
      box.querySelector('[data-pour-name]').textContent = names[step - 1];
      box.querySelector('[data-pour-deal]').textContent =
        count >= this.discountCount ? this.discountPercent + '% off + free shipping.' : count >= this.freeCount ? 'Free shipping. One more for ' + this.discountPercent + '% off.' : 'One more piece: free shipping.';
    }
});
